import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let event = useDataValue({
    viewPath: props.viewPath,
    context: 'event',
  })
  let schedulingConfig = useDataValue({
    context: 'timegrid',
    path: 'scheduling_config',
    viewPath: props.viewPath,
  })
  let isFullDayView = useDataValue({
    context: 'timegrid',
    path: 'is_full_day_view',
    viewPath: props.viewPath,
  })
  let slotInterval = useDataValue({
    context: 'timegrid',
    path: 'slot_interval',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'tab',
  })

  return () => {
    if (event.selected) {
      submit({ type: 'scheduling/deselectAnySlot' })
    } else {
      let shouldZoomIn =
        isFullDayView && schedulingConfig.duration < slotInterval
      submit({
        type: 'scheduling/selectTemplatedSlot',
        id: event.id,
        focus: shouldZoomIn,
        slot_interval: shouldZoomIn && 10,
      })
    }
  }
}

export function displayZoomIn({
  is_full_day_view,
  slot_interval,
  scheduling_config,
}) {
  return is_full_day_view && scheduling_config.duration < slot_interval
}
